import { render, staticRenderFns } from "./teachRecord.vue?vue&type=template&id=7f89bbcf&"
import script from "./teachRecord.vue?vue&type=script&lang=js&"
export * from "./teachRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports